<template>
    <div class="programme">
        <div class="container-lg d-flex-center flex-column py-5">
            <h1 class="text-center text-400">Nos podcasts</h1>

            <template v-for="podcast in podcasts">
                <div v-bind:key="podcast.date" class="separation"></div>

                <div v-bind:key="podcast.date">
                    <h2 class="d-flex flex-column">
                        <span>K6FM - {{ podcast.title }}</span>
                        <span class="fs-5 fw-light text-primary">{{ podcast.date }}</span>
                    </h2>
                    <p v-if="podcast.guest">{{ podcast.guest }}</p>
                </div>
                <iframe
                    v-bind:key="podcast.date"
                    v-bind:src="podcast.url"
                    class="mt-4"
                    width="100%"
                    height="520px"
                    scrolling="no"
                    frameborder="0"
                ></iframe>
            </template>

            <div class="separation"></div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            podcasts: [
                {
                    title: "COMMENT LA CAISSE D'EPARGNE ACCOMPAGNE LES PROJETS D'INNOVATION DANS LA RÉGION",
                    url: "https://playerbeta.octopus.saooti.com/miniplayer/default/351260?distributorId=1d49d413-ed4f-41c7-9ae5-35dfcb3dad7c&color=40a372&theme=ffffff",
                    date: "19 septembre 2023",
                    guest: "Invité : Grégory Louchet, directeur du développement entreprise et institutionnel à la Caisse d'épargne de Bourgogne Franche-Comté",
                },
                {
                    title: "ANALYSE DES MUTATIONS DANS LE MONDE DU TRAVAIL",
                    url: "https://playerbeta.octopus.saooti.com/miniplayer/default/333639?distributorId=1d49d413-ed4f-41c7-9ae5-35dfcb3dad7c&color=40a372&theme=ffffff",
                    date: "12 septembre 2023",
                    guest: "Invité : Nicolas Fernandez, délégué régional commercial chez Malakoff Humanis",
                },
                {
                    title: "COMMENT HABELLIS ACCOMPAGNE SES LOCATAIRES",
                    url: "https://playerbeta.octopus.saooti.com/miniplayer/default/302199?distributorId=1d49d413-ed4f-41c7-9ae5-35dfcb3dad7c&color=40a372&theme=ffffff",
                    date: "21 août 2023",
                    guest: "Invitée : Béatrice Gaulard, directrice générale d'Habellis",
                },
                {
                    title: "QUELLE EST LA SITUATION DU MARCHÉ AUTOMOBILE ?",
                    date: "19 juillet 2023",
                    url: "https://playerbeta.octopus.saooti.com/miniplayer/default/282237?distributorId=1d49d413-ed4f-41c7-9ae5-35dfcb3dad7c&color=40a372&theme=ffffff",
                    guest: "Invité : Antoine Mourot, Directeur de la concession automobile de Bourgogne, à Dijon",
                },
                {
                    title: "QUELLES PERSPECTIVES APRÈS LA CRISE ÉNERGÉTIQUE ?",
                    date: "30 juin 2023",
                    url: "https://playerbeta.octopus.saooti.com/miniplayer/default/269440?distributorId=1d49d413-ed4f-41c7-9ae5-35dfcb3dad7c&color=40a372&theme=ffffff",
                },
                {
                    title: "LA TRANSITION NUMÉRIQUE AVEC ATOL CONSEILS ET DÉVELOPPEMENTS",
                    date: "14 juin 2023",
                    url: "https://playerbeta.octopus.saooti.com/miniplayer/default/249714?distributorId=1d49d413-ed4f-41c7-9ae5-35dfcb3dad7c&color=40a372&theme=ffffff",
                    guest: "Invité : Christophe Gavignet, Directeur commercial et membre du comité de direction d'Atol Conseils et Développements",
                },
            ],
        };
    },
};
</script>
